<template>
  <div class="box">
    <div class="logoBox">
      <div class="container">
        <router-link :to="{ path: '/' }" class="logoImg">
          戏游互动
        </router-link>
        <div class="fr navBox">
          <a href="#/" class="router-link-active">首页</a>
          <a href="#/news" class="router-link-active">行业资讯</a>
          <a href="#/about" class="router-link-active">联系我们</a>
          <!-- <a href="#/help" class="router-link-active">帮助中心</a> -->
        </div>
      </div>
    </div>
    <div class="content" style="max-width: 900px;">
      <p class="title">联系我们</p>
      	<p><iframe width="504" height="425" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="http://j.map.baidu.com/s/rpGHFb"></iframe></p>

<p style="padding-left:30px;">联系方式：010-64002900</p>

<p style="padding-left:30px;">邮箱：qshealth_BD@qingsongchou.com</p>

<p style="padding-left:30px;">邮编：100088</p>

<p style="padding-left:30px;">地址：北京市海淀区北三环中路44号13号平房16号</p>


    </div>
    <el-dialog :visible.sync="dialogVisible" width="30%">
      <span>购买资讯费用,1元/条</span>
      <div class="fr">
        <el-button type="primary" @click="goPay">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import { dialog, button } from "element-ui";
export default {
  components: {
    elDialog: dialog,
    elButton: button,
  },
  data() {
    return {
      mockData: {},
      dialogVisible: false,
    };
  },
  methods: {
    async getMockData() {
      let res = (await import("../mall/home/mock/home.js")).default;
      this.mockData = res.data.news;
    },
    goPay() {
      this.dialogVisible = false;
       this.$router.push("/pay");
    },
    goHome() {
      this.$router.push("/");
    },
  },
  created() {
    this.getMockData();
  },
};
</script>
<style scoped>
.box {
  min-height: 100vh;
  background-color: #fff;
}
.logoBox {
  background-color: #fff;
  width: 100%;
  padding: 15px 0;
}
.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.logoImg {
  width: 120px;
  height: 70px;
  margin-left: 50px;
  font-family: PingFangSC-Medium, PingFang SC;
  color: #66beb2;
  font-size: 20px;
  vertical-align: middle;
}
.content {
  padding: 20px 0 0 200px;
}
li {
  border-top: 1px solid #dddfe3;
  height: 150px;
  width: 80%;
}
.title {
  font-family: PingFangSC-Medium, PingFang SC;
  font-size: 30px;
  margin-bottom: 20px;
}
.line-title {
  font-family: PingFangSC-Medium, PingFang SC;
  font-size: 30px;
  margin-bottom: 20px;
}
.line-new {
  line-height: 20px;
}
.more {
  display: inline-block;
  height: 15px;
  line-height: 15px;
  border-radius: 20px;
  padding: 0 5px;
  border: 1px solid #4593ff;
  font-size: 12px;
  color: #4593ff;
  margin-left: 10px;
}
.fr{
    float: right;
}
p{margin-bottom: 10px;
    text-indent: 2em;}
</style>



// WEBPACK FOOTER //
// src/pages/about/about.vue